import "./es.object.assign-7e79fd7b.js";
import { c as s } from "./index-8b07dec9.js";
import e, { css as n } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as I } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as S } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { CardIllustration as d } from "./cardIllustration.js";
import { FeatureText as f } from "./featureText.js";
import { RaisedSurface as c } from "./raisedSurface.js";
import { c as x } from "./childrenCountCheck-bbe924c6.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import { jsxs as h, jsx as o } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./es.symbol.description-6025a604.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./button.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./combineRefs-c9ad2c39.js";
import "./index-5d0f31c6.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./hTag.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
var v = /* @__PURE__ */ e.div.withConfig({
  displayName: "cardIllustrationSection__StyledCardIllustrationSection",
  componentId: "sc-7swjir-0"
})(["&.CardIllustrationSection{", ";}"], function(r) {
  var t = r.theme.components.cardIllustrationSection;
  return n(t.CardIllustrationSectionWrapper);
}), _ = /* @__PURE__ */ e.div.withConfig({
  displayName: "cardIllustrationSection__FeatureTextContainer",
  componentId: "sc-7swjir-1"
})(["&.CardIllustrationSection__FeatureTextContainer{", ";}"], function(r) {
  var t = r.theme.components.cardIllustrationSection;
  return n(t.FeatureTextContainer);
}), T = /* @__PURE__ */ e.div.withConfig({
  displayName: "cardIllustrationSection__CardIllustrationGroup",
  componentId: "sc-7swjir-2"
})(["&.CardIllustrationGroup{", ";}"], function(r) {
  var t = r.theme.components.cardIllustrationSection;
  return n(t.CardIllustrationGroup);
}), g = function(t) {
  var a = t.featureTextProps, m = t.enableRaisedSurface, i = m === void 0 ? !0 : m, p = t.children, u = S(p, {
    card: d
  }), C = I({
    label: "CardIllustrationSection"
  });
  x({
    additionalInfo: "Maximum card count exceeded. Max 6 cards are allowed in a Card Illustration Section.",
    children: p,
    componentName: "Card Illustration Section",
    maxChildren: 6
  });
  var l = /* @__PURE__ */ h(v, Object.assign({
    className: s(["CardIllustrationSection", {
      "CardIllustrationSection--raisedSurface": i
    }, {
      "CardIllustrationSection--featureTextDisabled": i && !a
    }])
  }, C, {
    children: [a && /* @__PURE__ */ o(_, {
      className: s(["CardIllustrationSection__FeatureTextContainer", {
        "CardIllustrationSection__FeatureTextContainer--raisedSurface": i
      }]),
      children: /* @__PURE__ */ o(f, Object.assign({}, a, {
        alignment: "center"
        // always should be center aligned
      }))
    }), /* @__PURE__ */ o(T, {
      className: "CardIllustrationGroup",
      children: u.card
    })]
  }));
  return i ? /* @__PURE__ */ o(c, {
    children: /* @__PURE__ */ o(c.Container, {
      children: l
    })
  }) : l;
};
g.Card = d;
export {
  g as CardIllustrationSection
};
